export class DoubleLinkedListNode<valueType> {
	prev: DoubleLinkedListNode<valueType> | null;
	next: DoubleLinkedListNode<valueType> | null;
	value: valueType;

	constructor(
		prev: DoubleLinkedListNode<valueType> | null,
		next: DoubleLinkedListNode<valueType> | null,
		value: valueType
	) {
		this.prev = prev;
		this.next = next;
		this.value = value;
	}

	disconnect() {
		if (this.prev) {
			this.prev.next = this.next;
		}
		if (this.next) {
			this.next.prev = this.prev;
		}
		this.prev = null;
		this.next = null;
	}

	*[Symbol.iterator]() {
		let current: DoubleLinkedListNode<valueType> | null = this;
		while (current) {
			yield current;
			current = current.next;
		}
	}
}

export class LinkedList<valueType> {
	head: DoubleLinkedListNode<valueType> | null;
	tail: DoubleLinkedListNode<valueType> | null;

	constructor() {
		this.head = null;
		this.tail = null;
	}

	getListIterator() {
		if (!this.head) return [];
		return [...this.head];
	}

	createPushNode(value: valueType) {
		const newNode = new DoubleLinkedListNode(null, null, value);
		this.pushNode(newNode);
		return newNode;
	}

	createUnShiftNode(value: valueType) {
		const newNode = new DoubleLinkedListNode(null, null, value);
		this.unshiftNode(newNode);
		return newNode;
	}

	unshiftNode(node: DoubleLinkedListNode<valueType>) {
		if (node === this.head) return this.head;
		if (!this.head) {
			this.head = this.tail = node;
			return node;
		}
		this.disconnectNode(node);
		node.next = this.head;
		this.head.prev = node;
		this.head = node;
		return this.head;
	}

	pushNode(node: DoubleLinkedListNode<valueType>) {
		if (node === this.tail) return this.tail;

		this.disconnectNode(node);

		if (!this.tail) {
			this.head = this.tail = node;
			return this.head;
		}
		node.prev = this.tail;
		this.tail = this.tail.next = node;

		return this.tail;
	}

	deleteNode(node: DoubleLinkedListNode<valueType>) {
		const prevNode = node.prev || node.next;

		this.disconnectNode(node);

		return prevNode;
	}

	disconnectNode(node: DoubleLinkedListNode<valueType>) {
		if (node === this.head) {
			this.head = node.next;
		}
		if (node === this.tail) {
			this.tail = node.prev;
		}
		node.disconnect();
		return node;
	}

	iterateFromNodeToIndex(
		node: DoubleLinkedListNode<valueType>,
		amount: number,
		isForward = true
	) {
		while (amount) {
			let newNode = node[isForward ? "next" : "prev"];
			if (!newNode) {
				newNode = isForward ? this.head : this.tail;
			}
			node = newNode!;
			amount--;
		}
		return node;
	}
}
